import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate, useLocation } from "react-router-dom";

export default function ExchangeSEBICompliances() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath === "/depository-participant-audit") setActiveTab("dp");
    else if (currentPath === "/system-audit-capital-market")
      setActiveTab("system");
    else if (currentPath === "/exchange-sebi-compliances")
      setActiveTab("exchange");
    else if (currentPath === "/ipo-listing-support") setActiveTab("ipo");
    else if (currentPath === "/capital-market-sebi") setActiveTab("capital");
  }, [location.pathname]);

  const handleTabClick = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
  };

  return (
    <>
      <Header />

      {/* ===== HERO SECTION ===== */}
      <section
        className="about-hero"
        style={{
          backgroundImage: "url('/assets/img/Achievements.jpg')",
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>Exchange & SEBI Compliances</h1>
          <p>
            Expert advisory and assistance in meeting SEBI and stock exchange
            compliance requirements for listed and unlisted companies.
          </p>
        </div>
      </section>

      {/* ===== TABS ===== */}
      <div className="tax-tabs">
        <button
          className={activeTab === "capital" ? "active" : ""}
          onClick={() => handleTabClick("capital", "/capital-market-sebi")}
        >
          Capital Market & SEBI Advisory
        </button>

        <button
          className={activeTab === "dp" ? "active" : ""}
          onClick={() => handleTabClick("dp", "/depository-participant-audit")}
        >
          Depository Participant (DP) Audit – NSDL/CDSL
        </button>

        <button
          className={activeTab === "system" ? "active" : ""}
          onClick={() =>
            handleTabClick("system", "/system-audit-capital-market")
          }
        >
          System Audit for Capital Market Intermediaries
        </button>

        <button
          className={activeTab === "exchange" ? "active" : ""}
          onClick={() =>
            handleTabClick("exchange", "/exchange-sebi-compliances")
          }
        >
          Exchange & SEBI Compliances
        </button>

        <button
          className={activeTab === "ipo" ? "active" : ""}
          onClick={() => handleTabClick("ipo", "/ipo-listing-support")}
        >
          IPO & Listing Support
        </button>
      </div>

      {/* ===== UPDATED SERVICE CONTENT ===== */}
      <section className="container my-5">

        <h2 className="section-title mb-4">Stock Exchange & SEBI Services</h2>

        <p className="service-text">
          Navigating the regulatory framework of Indian capital markets requires
          precision, expertise, and timely compliance. Our services provide
          end-to-end support to listed and unlisted companies for managing
          regulatory filings, approvals, compliance obligations, and complex
          matters involving Stock Exchanges and the Securities and Exchange Board
          of India (SEBI).
        </p>

        <p className="service-text mt-3">
          We act as a trusted advisor and liaison, ensuring businesses remain
          compliant, transparent, and well-governed while operating in dynamic
          capital markets.
        </p>

        <h3 className="dp-section-title mt-4">Our Services</h3>

        <div className="row g-4 mt-2">

          {/* CARD 1 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>1. Stock Exchange Listing & Issue Support</h4>
              <ul>
                <li>Assistance in new listing of securities on Stock Exchanges</li>
                <li>
                  Support for additional issue of shares in compliance with Listing
                  Regulations and SEBI guidelines
                </li>
                <li>
                  Advisory on listing requirements, disclosures, and post-listing
                  obligations
                </li>
              </ul>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>2. SEBI Regulatory Compliance</h4>
              <ul>
                <li>Compliance with SEBI (LODR) Regulations</li>
                <li>
                  Advisory and filings under SEBI (Substantial Acquisition of Shares
                  & Takeover) Regulations
                </li>
                <li>
                  Compliance with SEBI (Prohibition of Insider Trading) Regulations
                </li>
                <li>
                  Periodic and event-based disclosures as prescribed by SEBI
                </li>
              </ul>
            </div>
          </div>

          {/* CARD 3 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>3. Revocation & Trading Reinstatement</h4>
              <ul>
                <li>Advisory and documentation for revocation of suspension of trading</li>
                <li>
                  Representation before Stock Exchanges for re-listing and
                  reinstatement of securities
                </li>
                <li>Compliance rectification and follow-up with exchanges</li>
              </ul>
            </div>
          </div>

          {/* CARD 4 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>4. Takeover & Acquisition Compliance</h4>
              <ul>
                <li>
                  Structuring and compliance support for takeover of private and
                  listed companies
                </li>
                <li>
                  Preparation and filing of disclosures under SEBI Takeover Code
                </li>
                <li>
                  Coordination with Stock Exchanges, SEBI, and intermediaries
                </li>
              </ul>
            </div>
          </div>

          {/* CARD 5 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>5. Liaison with Regulatory Authorities</h4>
              <ul>
                <li>
                  End-to-end liaison with Stock Exchanges, SEBI, Depositories, RTAs
                </li>
                <li>
                  Handling regulatory queries, clarifications, notices, and approvals
                </li>
                <li>Support during inspections and regulatory reviews</li>
              </ul>
            </div>
          </div>

          {/* CARD 6 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>6. Ongoing Listing & Disclosure Compliance</h4>
              <ul>
                <li>
                  Compliance with all clauses of Listing Agreements and SEBI
                  Regulations
                </li>
                <li>
                  Assistance in corporate action compliances such as Bonus Issue,
                  Rights Issue, Preferential Allotment, ESOP disclosures
                </li>
                <li>Advisory on governance, disclosures, and risk mitigation</li>
              </ul>
            </div>
          </div>

        </div>

      </section>

      {/* WHY CHOOSE US */}
      {/* <div className="nri-highlight">
        <h3 className="mb-3">Why Choose Us?</h3>
        <ul>
          <li>Strong understanding of capital market regulations</li>
          <li>Proven experience with listed and unlisted entities</li>
          <li>Accurate, timely, and transparent regulatory execution</li>
          <li>Dedicated support for complex compliance matters</li>
        </ul>
      </div> */}

      <Footer />
    </>
  );
}
